export default "__VITE_ASSET__SOfyub0v__"